import React, { FC, useEffect, useState } from "react"
import { TopNav } from "./../components/index/TopNav";
import SEO from "./../components/seo";
import * as img from '../images/export';
import { Link } from "gatsby";
import { apiCall, logout } from "../../Helper";
import { toast } from "react-toastify";
import './../assets/styles/app.css'
import GIF from './../images/gif.gif'

interface ICard {
  width: string | number;
  height: string | number;
  title?: string;
  to?: string;
  href?: string;
}

const Card: FC<ICard> = ({ children, height, width, title, to, href }) => {
  if (to) {
    return <Link to={to}
      className="flexed align-c justify-c fdir-col"
      title={title}
      style={{ backgroundColor: "white", height, width, borderRadius: 5, boxShadow: "1px 1px 10px 1px #8080800d", cursor: "pointer" }}
    >
      {children}
    </Link>
  }
  return <a href={href}
    className="flexed align-c justify-c fdir-col"
    title={title}
    style={{ backgroundColor: "white", height, width, borderRadius: 5, boxShadow: "1px 1px 10px 1px #8080800d", cursor: "pointer" }}
  >
    {children}
  </a>

}

const Pre = () => {
  const numberStyle = { fontSize: "1.8rem" };
  const [count, setCount] = useState(0)

  function getNotifs() {
    apiCall({
      url: '/notification/list',
      params: { count: true }
    }).then(res => {
      if (res && res.data) {
        setCount(res.data.count)
      } else toast.error('مشکل در سیستم')
    }).catch(err => { toast.error('مشکل در سیستم') })
  }

  useEffect(getNotifs, [])

  return (
    <div style={{ overflowY: "auto", height: "100vh", overflowX: "hidden" }}>
      <SEO title="برترین سامانه تخصصی قوانین و مقررات مالیاتی کشور" />
      {/* Top-nav */}
      <TopNav />
      <div style={{
        // backgroundColor: "var(--silver)",
        backgroundColor: "rgb(191 191 191)",
        height: 80
      }} className="flexed fl-c">
        {/* <h2 style={{ fontSize: "2rem", fontWeight: "normal" }}>
          اینجـــا محـــل تبلیغــات شمــاست
        </h2> */}
        <img src={GIF} alt="" />
      </div>
      <div
        style={{ backgroundImage: `url(${img.pre_home_page})`, backgroundSize: "cover", minHeight: "calc(100vh - 128px)", width: "100vw", border: "none" }}
        className="flexed fdir-col align-c"
      >
        <div className="flexed justify-c pt-16">
          <img src={img.pre_main_logo} height="130" />
        </div>
        <div className="flexed justify-between mt-32" style={{ width: 270 }}>
          <Card width={75} height={60} title="پایانه های فروشگاهی" to={"/library/rules-qa-market"}>
            <span style={numberStyle}>3</span>
          </Card>
          <Card width={75} height={60} title="ارزش افزوده" to={"/library/rules-qa-afzoodeh"}>
            <span style={numberStyle}>2</span>
          </Card>
          <Card width={75} height={60} title="مالیات های مستقیم" to={"/library/rules-qa-mostagim"}>
            <span style={numberStyle}>1</span>
          </Card>
        </div>
        <div className="flexed justify-between mt-16" style={{ width: 270 }}>
          <Card width={75} height={60} to={"/user/notifs"}>
            <img src={img.pre_bell} height={40} alt="" />
            <span className="absolute text-tomato flexed align-c justify-c" style={{ top: 16, right: 16, backgroundColor: "var(--silver)", width: 20, height: 20, borderRadius: "0.5rem" }}>{count}</span>
          </Card>
          <Card width={75} height={60} to={"/me/todos"}>
            <img src={img.pre_calender} height={45} alt="" />
          </Card>
          <Card width={75} height={60} to={"/library/laws"}>
            <img src={img.pre_search} height={30} alt="" />
          </Card>
        </div>
        <div className="flexed justify-between mt-64" style={{ width: 800 }}>
          <Card width={150} height={130} to={"/library/laws"}>
            <img src={img.pre_rules} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>بخشنامه ها</span>
          </Card>
          <Card width={150} height={130} href={"/shop"}>
            <img src={img.pre_shop} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>فروشگاه</span>
          </Card>
          <Card width={150} height={130} to={"/news/list"}>
            <img src={img.pre_newspaper} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>اخبار</span>
          </Card>
          <Card width={150} height={130} to={"/library/rules"}>
            <img src={img.pre_library} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>کتابخانه</span>
          </Card>
        </div>
        <div className="flexed justify-between mt-32" style={{ width: 800 }}>
          <Card width={150} height={130} to={"/files/list"}>
            <img src={img.pre_tutorial} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>فایل آموزشی</span>
          </Card>
          <Card width={150} height={130} to={"/exam/list"}>
            <img src={img.pre_exam} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>آزمون</span>
          </Card>
          <Card width={150} height={130} to={"/me/library"}>
            <img src={img.pre_related_to_me} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>مرتبط با من</span>
          </Card>
          <Card width={150} height={130} to={"/hints"}>
            <img src={img.pre_help} height={40} alt="" className="mb-16" />
            <span style={{ fontWeight: 500 }}>راهنما</span>
          </Card>
        </div>
        <Link to="/pre" className="flexed align-c justify-c absolute pre-absolute-card pre-absolute-card-rtl" style={{ bottom: "3rem", right: 0 }}>
          <img src={img.pre_home} height={30} alt="" />
        </Link>
        <Link onClick={() => logout()} to="#" className="flexed align-c justify-c absolute pre-absolute-card pre-absolute-card-ltr" style={{ bottom: "6rem", left: 0 }}>
          <img src={img.pre_exit} height={30} alt="" />
        </Link>
        <Link to="/user/profile" className="flexed align-c justify-c absolute pre-absolute-card pre-absolute-card-ltr" style={{ bottom: "10.5rem", left: 0 }}>
          <img src={img.pre_user} height={30} alt="" />
        </Link>
        <Link to="/me-bought/nazarfani/" className="flexed align-c justify-c absolute pre-absolute-card pre-absolute-card-ltr" style={{ bottom: "15rem", left: 0 }}>
          <img src={img.pre_wallet} height={30} alt="" />
        </Link>
      </div>
    </div>
  )
}

export default Pre
